import { CurrencyData, Provider } from '../common/models';
import { ApiToken, UserDetails } from '../pages/cabinet/pages/profile/models';

export interface State {
  currencyData: CurrencyData[];
  providers: Provider[];
  error: unknown;
  scales: { [key: string]: number };
  userDetails: UserDetails;
  apiToken: ApiToken[];
  loading: boolean;
}

export const INITIAL_STATE = {
  currencyData: [],
  providers: [],
  scales: {},
  error: null,
  userDetails: null,
  apiToken: [],
  loading: false,
};
